/* eslint-disable react/jsx-props-no-spreading */
// DESIGN_SYSTEM_GENERATED_ICONS
import React from 'react';
import Icon from './icons';
function CirclePlayFilled(props) {
    return (React.createElement(Icon, Object.assign({ viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 7.03 16.97 3 12 3ZM15.54 12.35L10.13 15.68C9.85 15.85 9.49 15.65 9.49 15.33V8.67C9.49 8.34 9.85 8.14 10.13 8.32L15.54 11.65C15.81 11.81 15.81 12.19 15.54 12.35Z", fill: "#001325", fillOpacity: "0.92" })));
}
export default CirclePlayFilled;
